import { Box } from "@mui/material";
import React from "react";
import Footer from "../../global/Footer";
import Navbar from "../../global/Navbar";

const Sep15 = () => {
  return (
    <Box
      sx={{
        width: { xs: "90vw", md: "50vw" }, // 90% viewport width on mobile, 50% on desktop
        margin: "0 auto", // Center horizontally
        minHeight: "100vh", // Full height
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        p: { xs: 2, md: 4 }, // Less padding on mobile, more on desktop
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <Navbar />
      {/* Title */}
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        What I learned deploying my app to AWS
      </Box>
      {/* Date */}
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>Sept 15</Box>
      {/* Content */}
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        I will be talking about what I learned deploying my app to AWS, why I am
        even deploying my app on AWS, the resources I found for deploying a
        Prisma app on AWS and a basic high level on how to deploy a Prisma app,
        all the main steps, for someone who is deploying on AWS for the first
        time. To begin I have been building this app on my local machine and it
        is a order management system built to manage orders in a small business.
        The goal is to be able to place orders from different stores and have a
        warehouse manager verify/process all the orders and create a custom
        order. The way it works is stores simply store their orders in a
        database along with their storeId and the manager can fetch all the
        orders from all the stores. This is the functionality I had on my local
        machine, a simple CRUD app. The goal was for a sales person working in a
        actual store to be able to login to our company url and place the order
        which is why I figured to deploy to AWS. Previously I had two pieces of
        experience. One is deploying a vercel app with just one click and adding
        a custom domain. That requires buying a domain on godaddy or cloudfare
        and setting up the dns settings on cloudfare and vercel so that requests
        made to the domain you bought points to your vercel app. Second was
        watching a youtube tutorial of building a full stack real estate app
        from scratch and deploying it on amplify, backend on ec2 and rds. With
        these two pieces of info, I thought I could deploy my app on AWS. The
        ec2 instance that was running to keep my app deployed ended up costing a
        bit of money so I had to shut that down and could not keep my
        deployment. It went past the no cost budget pretty fast. I wanted to
        deploy for free which I was figuring out if there was any options to do
        so on AWS. Additionally deploying on EC2 was a bit complicated from the
        tutorial since you had to configure on a virtual terminal so this time
        around I was exploring another free service. Chatgpt recommended lambda
        and dynamodb and this seemed like pretty common services. I have heard
        of dynamodb looking through job descriptions and thought it was just
        another sql or nosql database since the name is similar to mongodb. I
        was working with a prisma app since that was what I learned from the
        youtube tutorial so I researched how to deploy prisma on lambda. I could
        not find one concreate video, a handheld tutorial of someone doing the
        same exact thing so this was a bit more difficult than I thought. I did
        find some videos on end to end deploy a full stack app, to-do list, on
        amplify, lambda and dynamodb so I follwed that tutorial and learned how
        the lambda function works, how to set up dynamodb and how lambda links
        with dynamo and how amplify links with lambda. At the time after setting
        up dynamodb it seemed way easier with just a click, little to no
        configuration whereas rds, there were production configurations free
        tier configurations, security groups and vpcs, securing your db,
        different nodejs versions, cpu etc. Dynamodb was much simpler but it was
        for nosql databases and I had a sql database so I thought redesigning my
        data models would not be easy so I should figure out this rds. At the
        end of the tutorial I had a handy to-do list with a pretty good UI that
        I can use. The next important video I found was how to set up a rds
        database and connect to it on pgadmin. I had already been using pgadmin
        for my local projects to view the contents of my postgres db and
        realizes you cannot view the contents of a rds db like you can a dnamodb
        on aws. So I found out that you actually set up the schema
        representation of a rds db from your local machine by performing the
        same prisma migrations and seed the data as a local app. You just create
        a new db with the aws endpoint and port number. Now that my db migrated
        successfully, I was able to seed the data I get some data from my db.
        This is the part where I have to deploy my backend functions on lambda.
        Turns out I deploy my whole app as one single function. But it requires
        javascript and mine was written in typscript. I looked into the dist
        folder and found the javascript version of my code and dragged that into
        the lambda function to see if it would work. The javascript looked
        complicated, not like the other javascript that I wrote before but if it
        was a translation of my typescript code then it should work. After
        playing with the folder structure, I figured the index.js file should be
        accessible so I did that and kept my other folders in the same layers. I
        ran into the problem of the folder size, thinking to put the node
        modules in but that exceeded the limit for lambda function code fast so
        I found out nodemodules usually are deployed in the layers so it can be
        accessed by multiple functions using the same node modules. I deployed
        as a layer and it was still too large so I had to strip it down removing
        unneccessary packages to reduce the size. Finally nodemodules layer was
        set up. From the tutorial for deploying the to do list, it was similar
        in that I also had a express app so I learned how to set that up. I
        downloaded the severless http package, imported it in the index file and
        wrapper my app in the serverless function, and exported the app. Now the
        express app is set up as a lambda function. I checked one of my global
        routes to see if I could get the data, updated my database url to the
        full postgres url not just the rds endpoint and I could access global
        data on the lambda url. lambda and rds is connected. I had already
        deployed my frontend for a while now on amplify and I did that by
        building the app on my local machine making sure there are no build
        errors and pushing the prod ready deployment. After building it fixing
        the errors, my app shows up on amplify. I was suprised that smplify
        could access data from my server since I did not set up a server at the
        time but it could not post data. Logins and signup worked so cognito was
        working. My frontend was already on amplify and I had a lambda that
        connects to rds, now I need to connect my frontend to backend. This is
        what apigateway should be for. I set up some proxys so that I dont have
        to write out each individual route and ended up defining my main routes,
        global, sales and manager, with a proxy for each. To connect api gateway
        to lambda, i had to integrate the lambda function when setting up a
        method since it doesnt allow you to deploy the api without the
        functionality intergrated. now apigateways connects to lambda. I test
        the api gateway url for my global data and receive it. In the to-do
        list, he connects the amplify frontend with api gateway by adding the
        apigateway url as his baseurl for his frontend in the environment
        variables. I set up the frontend environemnt variables on amplify.
        Frontend connects to apigateway which connects to backend. I test the
        app and there were sign in issues. There were some cors issues that did
        not let me create a new user so I disable cors. I was able to signin,
        signup but I could not get any data since that required cors to be set
        up. Trying to debug the errors 502 bad gateway, 401 unauthorized, 403
        forbidden, I found out the configuration that worked was no cors set up
        with a post method, which was covered by a any method, with a cognito
        authorizer attached allowed me to sign in. Once signed in I needed cors
        enabled on the proxy path and I could get my data from the backend. I
        could not turn on cors after signing in so I was not configuring this
        right. I found out cognito is unrelated to api gateway which made sense,
        I was able to signin and signup when I only had my frontend deployed so
        I could turn off the authorizer. After querying Chatgpt, it said the
        options requests hits apigateway before cognito which is why after a
        successful signup, I can not store a new user since cors is not set so I
        set up a post method with cors enabled on it on the user initial path,
        not proxy. It also said to set up get, options and post in the
        integration response so I added the get, made sure all three and it
        worked. I can login and get data as well. My app is finally deployed. I
        thought deploying a prisma app was gonna be difficult since there are
        not many tutorials that deploy a prisma app but prisma migrate sets up
        the relations in the database and prisma compiles javascript code so
        those parts are similar. Another thing is the nodemodules layer, since
        aws runs on linux, I had to compile linux binaries and deploy that on
        the layer while my local machine uses mac os.
      </Box>
      <Footer />
    </Box>
  );
};

export default Sep15;
